import { RelationShipScreen } from "../../../../../../screens/RelationshipsScreens/RelationShipScreen";
import { IUBusRelationshipGroupItems } from "../../../../../../models/u-bus-relationship-group-item";
import MainApi from "../../../../../../services/mainApi.service";
import { memo, useCallback, useMemo, useState } from "react";
import { Box } from "@mui/material";
import { GridRowParams } from "@mui/x-data-grid";
import { UBusRelationshipGroupItem } from "./RelationshipGroupItem/RelationshipGroupItem";
import { useParams } from "react-router-dom";

const U_BUS_RELATIONSHIP_GROUP_ITEM_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/4uBusRelationshipGroupItem/";
const uBusRelationshipGroupItemService =
  new MainApi<IUBusRelationshipGroupItems>(U_BUS_RELATIONSHIP_GROUP_ITEM_ROUTE);

export const RelationshipGroupItemPage = memo(
  ({ uBusAutomationCode }: { uBusAutomationCode?: number }) => {
    const { id: uBusRelationshipGroupId } = useParams();

    const [relationshipFormScreen, setrelationshipFormScreen] = useState(false);

    const [selectedId, setSelectedId] = useState<string>();

    const handleAdd = () => {
      setrelationshipFormScreen(true);
    };

    const handleRowClick = (
      params: GridRowParams<IUBusRelationshipGroupItems>,
    ) => {
      if (!params.row) return;
      setrelationshipFormScreen(true);
      setSelectedId(params.row.id);
    };

    const handleBack = useCallback(() => {
      setSelectedId(undefined);
      setrelationshipFormScreen(false);
    }, []);

    const props = useMemo(() => {
      return {
        _4uBusRelationshipGroupId: uBusRelationshipGroupId ?? "",
      };
    }, [uBusRelationshipGroupId]);

    return (
      <Box sx={{ height: 600, width: "100%" }}>
        {relationshipFormScreen && (
          <Box
            sx={(t) => ({
              p: 1,
              px: 10,
              width: "100%",
              height: "100%",
              overflow: "auto",
              backgroundColor: t.palette.background.default,
              borderRadius: 1,
            })}
          >
            <UBusRelationshipGroupItem
              id={selectedId}
              uBusRelationshipGroupId={uBusRelationshipGroupId}
              onBackButton={handleBack}
              uBusAutomationCode={uBusAutomationCode}
            />
          </Box>
        )}
        {!relationshipFormScreen && (
          <Box height={600}>
            <RelationShipScreen<IUBusRelationshipGroupItems>
              isTag
              customProps={props}
              service={uBusRelationshipGroupItemService}
              customHandleAdd={handleAdd}
              customHandleRowClick={handleRowClick}
            />
          </Box>
        )}
      </Box>
    );
  },
);
